import * as React from "react";
import type { SVGProps } from "react";
const SvgTvIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 28 28"
    {...props}
  >
    <g clipPath="url(#tv-icon_svg__a)">
      <path
        fill="#858585"
        d="M0 5.04v17.92h28V5.04zm1.12 1.12h25.76v15.68H1.12zm12.828 3.343-.07.017a.56.56 0 0 0-.438.56v4.48a.56.56 0 0 0 .278.492c.175.1.39.1.564 0a.56.56 0 0 0 .278-.492v-4.48a.56.56 0 0 0-.613-.577m-2.188.7a1 1 0 0 0-.088.017.56.56 0 0 0-.227.105A4.49 4.49 0 0 0 9.52 14 4.49 4.49 0 0 0 14 18.48 4.49 4.49 0 0 0 18.48 14a4.49 4.49 0 0 0-1.925-3.675.56.56 0 1 0-.63.928A3.33 3.33 0 0 1 17.36 14 3.35 3.35 0 0 1 14 17.36 3.35 3.35 0 0 1 10.64 14c0-1.146.564-2.14 1.435-2.748a.56.56 0 0 0-.315-1.05M6.055 24.08a.564.564 0 0 0 .105 1.12h15.68a.56.56 0 0 0 .492-.278c.1-.175.1-.39 0-.564a.56.56 0 0 0-.492-.278H6.055"
      />
    </g>
    <defs>
      <clipPath id="tv-icon_svg__a">
        <path fill="#fff" d="M0 0h28v28H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgTvIcon;
